const listPortrait = document.querySelector(
    '.vp-block-home-references .list-portrait',
)
const listPaysage = document.querySelector(
    '.vp-block-home-references .list-paysage',
)
const listText = document.querySelector('.vp-block-home-references .list-text')
const current = document.querySelector('.vp-block-home-references .current')

if (listPortrait && listPaysage && listText) {
    listText.addEventListener('change', (e) => {
        current.textContent = e.detail.index + 1
        listPortrait.goTo(e.detail.index)
        listPaysage.goTo(e.detail.index)
    })
}
